<template>
  <div class="pt-5 m-0" v-if="cargado">
    <div class="container d-none d-md-block">
      <div class="animated fadeInUp">
        <carousel
            :items="1"
            :loop="true"
            :autoplay="true"
            :dots="false"
            :nav="false"
            :autoplayTimeout="retardo"
        >
          <template v-for="(i,ii) in imagenes">
            <a :href="i.dt3 ? i.dt3 : false" v-bind:target="i.dt3 ? '_blank' : null" :key="ii" class="item">
              <img
                  :alt="ii+' img lg'"
                  :src="i.dt1 ? i.dt1 : espera"
                  :src-placeholder="espera"
              />
            </a>
          </template>
        </carousel>
      </div>
    </div>
    <div class="d-md-none">
      <div class="animated fadeInUp">
        <carousel
            :items="1"
            :loop="true"
            :autoplay="true"
            :dots="false"
            :nav="false"
            :autoplayTimeout="retardo"
        >
          <template v-for="(i,ii) in imagenesSm">
            <a :href="i.dt3 ? i.dt3 : false" v-bind:target="i.dt3 ? '_blank' : null" :key="ii" class="item">
              <img
                  :alt="ii+' img sm'"
                  :src="i.dt1 ? i.dt1 : esperaSm"
                  :src-placeholder="esperaSm"
              />
            </a>
          </template>
        </carousel>
      </div>
    </div>
  </div>
</template>
<script>
import {banners} from "../servicios";
import carousel from 'vue-owl-carousel';

export default {
  name: "banners",
  components: {
    carousel
  },
  data: () => ({
    imagenes: [],
    imagenesSm: [],
    espera: require("../assets/images/loader_banner.jpg"),
    esperaSm: require("../assets/images/loader_banner_sm.jpg"),
    cargado: false,
    retardo: 7000
  }),
  methods: {
    cargarBanners() {
      this.cargado = false;
      banners.listado().then(r => r.data).then(response => {
        if (response.length) {
          this.imagenesSm = response[0];
          this.imagenes = response[1];
          this.cargado = true;
        }
      });
    }
  },
  created() {
    this.cargarBanners();
  }
}
</script>

<style scoped>

</style>
